module.exports = __webpack_public_path__ + "static/media/shdocvw_257.0fddce39.ico";